export const pieChart = {
  name: "pie-chart" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M13.1 3a.9.9 0 0 1 .9-.9 8.4 8.4 0 0 1 8.4 8.4.9.9 0 0 1-.9.9H14a.9.9 0 0 1-.9-.9V3Zm1.8.96V9.6h5.64a6.604 6.604 0 0 0-5.64-5.64Zm-6.3 4a6.601 6.601 0 1 0 7.44 7.44H9.5a.9.9 0 0 1-.9-.9V7.96ZM1.1 14.5a8.4 8.4 0 0 1 8.4-8.4.9.9 0 0 1 .9.9v6.6H17a.9.9 0 0 1 .9.9 8.4 8.4 0 1 1-16.8 0Z" clip-rule="evenodd"/></svg>`,
  keywords: ["pie-chart"],
  category: "file" as const,
};
